export default __webpack_public_path__ + "static/media/mark.b26e2cce.png";